module.exports = __webpack_public_path__ + "static/media/lio-topo.2d98708b.png";